import api from "./Api";

class TecnicoEmailService {
  GetTecnicoEmail(payload) {
    return api.get("/v1/tecnicoEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTecnicoEmail(payload) {
    return api.post("/v1/tecnicoEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutTecnicoEmail(payload) {
    return api.put("/v1/tecnicoEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTecnicoEmail(payload) {
    return api.delete("/v1/tecnicoEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTecnicoEmailOData(payload) {
    return api.get("/OData/TecnicoEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TecnicoEmailService();
